<mat-form-field class="w-100">
  <mat-label>Filter</mat-label>
  <input matInput [formControl]="searchControl" (keyup)="applyFilter()" placeholder="Ex. Mia" #input />
</mat-form-field>
<mat-card class="w-100">
  <mat-card-content>
    <mat-grid-list cols="1" rowHeight="50px">
      <mat-card-title>User List</mat-card-title>
      <mat-grid-tile>
        <button mat-raised-button color="primary" (click)="addUser()">
          <span>Add User</span>
        </button>
      </mat-grid-tile>
    </mat-grid-list>
    <div class="spinner" *ngIf="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div [hidden]="spinner" class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="text-nowrap w-100" matSort>
        <!-- Company Name Column -->
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Company Name
          </th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.companyName }}</p>
          </td>
        </ng-container>

        <!-- Username Column -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.username }}</p>
          </td>
        </ng-container>

        <!-- Address Column -->
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">City : {{ element.city }}</p>
            <p class="mb-0 fw-medium">State : {{ element.state }}</p>
            <p class="mb-0 fw-medium">Pincode : {{ element.pincode }}</p>
          </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.phone }}</p>
          </td>
        </ng-container>

        <!-- App Version Column -->
        <ng-container matColumnDef="appVersion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>App Version</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge bg-light-primary text-primary fw-semibold" *ngIf="element.appVersion">
              {{ element.appVersion }}
            </span>
            <span class="text-muted" *ngIf="!element.appVersion">-</span>
          </td>
        </ng-container>

        <!-- Image Column -->
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Image</th>
          <td mat-cell *matCellDef="let element">
            <div class="avatar" *ngIf="!element.image">
              {{ element.username.charAt(0).toUpperCase() }}
            </div>
            <img *ngIf="element.image !== null" src="{{ environmentURL + '/' + element.image }}" alt=""
              class="preview" />
            <!-- <p class="mb-0 fw-medium">{{ element.image }}</p> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-center">Action</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <button mat-icon-button aria-label="Edit" (click)="onEdit(element._id)">
              <mat-icon color="warn">edit</mat-icon>
            </button>
            <button mat-icon-button aria-label="Delete" (click)="onDelete(element._id)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">
            No data matching the filter "{{ input.value }}"
          </td>
        </tr>
      </table>
    </div>
    <mat-paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
      [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons aria-label="Select page of users">
    </mat-paginator>
  </mat-card-content>
</mat-card>